import useApplicationStore from '@my-pages/stores/useApplicationStore.tsx';

export const useGetUser = () => {
    const user = useApplicationStore((state) => state.user);
    return user;
};
